import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaLink } from "../ui/CtaLink";
import { Reveal } from "../ui/Reveal";
import { DemoViewer } from "../demo/DemoViewer";
export function DemoSection() {
  return <section className="shell section border-t border-line" data-id="element-133" data-mp="par1ypvpqei6">
      <SectionHeading align="split" eyebrow="Live demo" title="See a build on every screen." lead="Switch between desktop and mobile, or go full-screen. This sample restaurant site shows how a NEXORA build adapts." action={<CtaLink to="/demo" variant="ghost" track="home_demo_open" data-id="element-135" data-mp="1d0v56w4zoc8n">Open live demo <ArrowUpRightIcon className="h-4 w-4" data-id="element-136" data-mp="1818o2bm1ibuk" /></CtaLink>} data-id="element-134" data-mp="p9fv2h6z0qmu" />
      <Reveal data-id="element-137" data-mp="181s57q3v8w7j">
        <DemoViewer data-id="element-138" data-mp="183bmnk19ddaw" />
      </Reveal>
    </section>;
}